import React from 'react';

export default function SectionHeader({ title }: { title: string }) {
  return <h5 className="fw-semibold mb-4">{title}</h5>;
}
